var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUparrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chevron"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.9006 15.8254C19.022 15.9373 19.1855 16 19.356 16C19.5264 16 19.69 15.9373 19.8113 15.8254C19.8711 15.7704 19.9185 15.7048 19.9509 15.6325C19.9833 15.5601 20 15.4825 20 15.4041C20 15.3257 19.9833 15.2481 19.9509 15.1758C19.9185 15.1034 19.8711 15.0379 19.8113 14.9828L12.4553 8.17461C12.334 8.06273 12.1704 8 12 8C11.8296 8 11.666 8.06273 11.5447 8.17461L4.1887 14.9828C4.12894 15.0379 4.08148 15.1034 4.04908 15.1758C4.01668 15.2481 4 15.3257 4 15.4041C4 15.4825 4.01668 15.5601 4.04908 15.6325C4.08148 15.7048 4.12894 15.7704 4.1887 15.8254C4.31003 15.9373 4.4736 16 4.64403 16C4.81446 16 4.97804 15.9373 5.09936 15.8254L12.0005 9.61625L18.9006 15.8254Z",
    fill: "white",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUparrow);
export default __webpack_public_path__ + "static/media/Uparrow.53b32810beeffa4ec8c58270885cfe97.svg";
export { ForwardRef as ReactComponent };